import { Box, Popover, Text } from '@bechtel/gds';
import { CommodityStatusCode, PersonaType } from '@bechtel/types';
import { t } from '@lingui/macro';
import { useLingui } from '@lingui/react';
import { find, map, orderBy } from 'lodash';
import { FC, useRef, useState } from 'react';
import { WeldStatusMessages } from '~/components';
import { WeldoutListProps } from '../metadata/types';
import { WeldStatusItemStyled } from './styled';

export const WeldoutList: FC<WeldoutListProps> = ({ weldStatuses, justifyContent = 'center', showTooltip = true }) => {
  const { i18n } = useLingui();
  const [weldStatusHovered, setWeldStatusHovered] = useState<string | null>();
  const popoverTrigger = useRef(null);
  const assignedStatusText = t`Assigned`;
  const unAssignedStatusText = t`UnAssigned`;

  const orderByWeldStatus = orderBy(
    weldStatuses,
    (weld) =>
      weld?.status?.status ||
      (find(weld.commodityAssignees, (item) => {
        return item.personaType === PersonaType.FOREMAN;
      })
        ? assignedStatusText
        : unAssignedStatusText)
  );
  return (
    <div ref={popoverTrigger}>
      <Box
        justifyContent={{ sm: justifyContent }}
        mt={{ sm: '400' }}
        onMouseLeave={(event) => {
          event.stopPropagation();
          setWeldStatusHovered(null);
        }}
      >
        {weldStatuses &&
          map(orderByWeldStatus, (weldoutItem) => {
            const commodityAssignee = find(weldoutItem.commodityAssignees, (item) => {
              return item.personaType == PersonaType.FOREMAN;
            });
            const assignedWeldForeman = commodityAssignee?.assignee;
            return (
              <WeldStatusItemStyled
                data-testid="weldout-item"
                key={weldoutItem.id}
                isAssigned={assignedWeldForeman ? true : false}
                status={weldoutItem?.status?.status}
                totalWelds={weldStatuses?.length}
                onMouseOver={(event) => {
                  event.stopPropagation();
                  setWeldStatusHovered(
                    weldoutItem?.status?.status === CommodityStatusCode.READY_TO_WELD
                      ? assignedWeldForeman
                        ? i18n._(WeldStatusMessages[weldoutItem?.status?.status])
                        : unAssignedStatusText
                      : i18n._(WeldStatusMessages[weldoutItem?.status?.status])
                  );
                }}
              ></WeldStatusItemStyled>
            );
          })}
        <Popover triggerComponentRef={popoverTrigger} showPopper={showTooltip && !!weldStatusHovered} placement={'top'}>
          <Box p={{ sm: '400' }}>
            <Text color="grey.600" size="300">
              {weldStatusHovered}
            </Text>
          </Box>
        </Popover>
      </Box>
    </div>
  );
};
